module.exports = __webpack_public_path__ + "img/hotcms.e9c2073d.png";